module.exports = __webpack_public_path__ + "static/media/finance_overview.220618f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/finance_overview.png
// module id = 250
// module chunks = 0